import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";

export async function remove(id) {
  const axios = axiosInstance().primoLab;
  let testWorkQueue = [];

  await axios
    .delete(`/test-work-queues/${id}`)
    .then(async (response) => {
      testWorkQueue = response.data;
    })
    .catch(async (error) => {
      throw error.response.data.errors;
    });

  return { testWorkQueue };
}
